export enum PublicPaymentMethodPropertyCode {
  PayUSecureForm = 'PAYU_SECURE_FORM',
}
